import React from 'react'
import { search } from './assets'
import colors from '../../../utils/colors'

interface IProps {
    className: string
    placeholderText: string
    handleChange: (val: string) => void
    width?: string
    height?: string
    value?: string
}
const SearchBar = ({ className, handleChange, placeholderText, height,width, value }: IProps) => {
    return (
        <div className='flex relative items-center' style={{height, width, minWidth: '120px'}}>
            <input
                className={`relative rounded-md w-full text-xs border-[1px] pl-[35px] pr-2 py-2 placeholder:text-[#606060] outline-none ${className}`} 
                onChange={(e) => handleChange(e.target.value)}
                style={{ borderColor: colors.grey }}
                placeholder={placeholderText}
                value={value}
            />
            <img 
                src={search} 
                alt='' 
                className='absolute left-[10px] h-[15px] w-[15px] pointer-events-none' 
            />
        </div>
    )
}

export default SearchBar